// extracted by mini-css-extract-plugin
export default {"status-container":"BadgeStatus_status-container__yroTT","completed":"BadgeStatus_completed__vDBjK","duplicate":"BadgeStatus_duplicate__gAH-X","failed":"BadgeStatus_failed__G79o0"};